__turbopack_context__.v({
  "container": "noooSG_container",
  "description": "noooSG_description",
  "link": "noooSG_link",
});
